import React from 'react';
import { Page } from 'components';
import ReferenceDataDetailProvider from './ReferenceDataDetailContext';
import ReferenceDataDetail from './ReferenceDataDetail';


let Index = () => {
    return (
        <ReferenceDataDetailProvider>
            <Page title="Reference data" maxWidth='md'>
                <ReferenceDataDetail />
            </Page>
        </ReferenceDataDetailProvider>
    );
}

export default Index;